
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const colorPresets = [
  { name: 'Azul', value: '#3B82F6' },
  { name: 'Verde', value: '#10B981' },
  { name: 'Roxo', value: '#8B5CF6' },
  { name: 'Rosa', value: '#EC4899' },
  { name: 'Vermelho', value: '#EF4444' },
  { name: 'Laranja', value: '#F59E0B' },
  { name: 'Indigo', value: '#6366F1' },
  { name: 'Teal', value: '#14B8A6' },
  { name: 'Preto', value: '#000000' },
  { name: 'Branco', value: '#FFFFFF' },
  { name: 'Cinza', value: '#6B7280' },
  { name: 'Cinza Escuro', value: '#374151' }
];

const gradientPresets = [
  { name: 'Sunset', value: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
  { name: 'Ocean', value: 'linear-gradient(135deg, #2196F3 0%, #00BCD4 100%)' },
  { name: 'Forest', value: 'linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)' },
  { name: 'Fire', value: 'linear-gradient(135deg, #FF5722 0%, #FF9800 100%)' },
  { name: 'Purple', value: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 100%)' },
  { name: 'Gold', value: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)' }
];

interface ColorPaletteProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  showGradients?: boolean;
}

export function ColorPalette({ label, value, onChange, showGradients = false }: ColorPaletteProps) {
  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">{label}</Label>
      
      {/* Color Input */}
      <div className="flex items-center gap-2">
        <Input
          type="color"
          value={value.startsWith('#') ? value : '#3B82F6'}
          onChange={(e) => onChange(e.target.value)}
          className="w-12 h-10 p-1 rounded-lg border"
        />
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#3B82F6"
          className="flex-1"
        />
      </div>

      {/* Color Presets */}
      <div className="grid grid-cols-6 gap-2">
        {colorPresets.map((preset) => (
          <Button
            key={preset.value}
            variant="outline"
            size="sm"
            className="h-8 w-full p-0 border-2"
            style={{ backgroundColor: preset.value }}
            onClick={() => onChange(preset.value)}
            title={preset.name}
          />
        ))}
      </div>

      {/* Gradient Presets */}
      {showGradients && (
        <div className="space-y-2">
          <Label className="text-xs text-gray-600">Gradientes</Label>
          <div className="grid grid-cols-3 gap-2">
            {gradientPresets.map((preset) => (
              <Button
                key={preset.value}
                variant="outline"
                size="sm"
                className="h-8 w-full p-0 border-2"
                style={{ background: preset.value }}
                onClick={() => onChange(preset.value)}
                title={preset.name}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
